import { render, staticRenderFns } from "./GroupInsurancePolicyNew.vue?vue&type=template&id=194375c6"
import script from "./GroupInsurancePolicyNew.vue?vue&type=script&lang=js"
export * from "./GroupInsurancePolicyNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports